import { ComponentType } from 'react';
import { UnsupportedAnswerView } from '../primitives/shared/UnsupportedAnswerView';
import { QuestionViewProps, SupportedQuestionType } from '../types';
import { AnswerMap } from './answersMap';

export function createAnswerResolver(
  views: AnswerMap,
  mode: 'standard' | 'correction',
): ComponentType<QuestionViewProps> {
  function AnswerResolver(props: QuestionViewProps) {
    const type = props.question.type as SupportedQuestionType;
    const View = (views[type]?.[mode] ??
      UnsupportedAnswerView) as ComponentType<QuestionViewProps>;
    return <View {...props} />;
  }

  return AnswerResolver;
}
